import React, { useEffect, useState } from "react";
import { useContext } from "react";
import ReactPlayer from "react-player";
import { serverInfo } from "../../../App";
import Pagination from "../../../Components/Reuseable/Pagination";

const AuditionApproveFilterVideo = (props) => {

  const { imageCdnUrl, videoCdnUrl } = useContext(serverInfo);

  const [currentPage, setCurrentPage] = useState(1);

  const { data, handleSelectedVideo, selectedVideo, handlePageChange } = props;
  const [videoPlay, setVideoPlay] = useState(false);
  const [activeVideoIndex, setActiveVideoIndex] = useState(null);





  const handlePageClick = (event) => {

  };

  const handleVideoPlay = (index, player) => {
    if (activeVideoIndex !== index) {
      setActiveVideoIndex(index);
    }
    // You can access the playing component through the 'player' argument here.
    console.log('Playing component:', player);
  };


  return (
    <>
      {data?.data?.length === 0 ? (
        <h6 className="text-danger text-center w-100"> No Video</h6>
      ) : (
        <>
          <div className="py-3">
            <div className="row justify-content-md-between justify-content-lg-center">
              {data?.data?.map((event_data, index) => {
                return (
                  <div className="col-sm-12 col-md-6 col-lg-3 mb-3" key={index}>
                    <div
                      className=""
                      onClick={() => handleSelectedVideo(event_data)}
                      style={{
                        // height: "200px",
                        width: "290px",
                      }}
                    >
                      {selectedVideo ? (
                        <ReactPlayer
                          className="videosww"
                          url={videoCdnUrl + event_data.video}
                          controls={true}

                          volume={1}
                          width="290px"
                          height="200px"
                          style={
                            selectedVideo.id === event_data.id
                              ? {
                                border: "7px solid gold",
                                borderRadius: "20px",
                              }
                              : null
                          }
                          //playing={videoPlay}
                          playing={activeVideoIndex === index}
                          onPlay={() => handleVideoPlay(index, this)}
                        //onClick = {handlePlayVideo}
                        //onPlay = {handlePlayVideo2}
                        />
                      ) : (
                        <ReactPlayer
                          url={videoCdnUrl + event_data.video}
                          controls={true}
                          playing={videoPlay}
                          volume={1}
                          width="290px"
                          height="200px"
                          style={{ margin: "0 auto" }}
                        />
                      )}

                      <span className="row justify-content-center">
                        <div className="col-4"></div>
                        <div className="col-8 row">
                          <img
                            src={imageCdnUrl + event_data.user?.image}
                            className="col-4"
                            style={{ width: "30px", height: "30px" }}
                            alt=""
                          />
                          <p className="text-light col-8">
                            {event_data.user?.first_name}{" "}
                            {event_data.user?.last_name}
                          </p>
                        </div>
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div id="react-paginate">
            {data?.data && (
              <Pagination links={data.links} onPageChange={handlePageChange} />
            )}

          </div>
        </>
      )}
    </>
  );
};

export default AuditionApproveFilterVideo;
